<script>
import {
  LogPrivateAdCarClick,
  LogPrivateAdVanClick,
  LogPrivateAdMotorcycleClick,
  LogPrivateAdCaravanClick,
} from '@/events'

export default {
  template: '<template></template>',
  mounted() {
    this.handleCar()
    this.handleVan()
    this.handleMotorcycle()
    this.handleCaravan()
  },
  methods: {
    handleCar() {
      this.handleLink('js-private-ad-car', () => {
        LogPrivateAdCarClick()
      })
    },
    handleVan() {
      this.handleLink('js-private-ad-van', () => {
        LogPrivateAdVanClick()
      })
    },
    handleMotorcycle() {
      this.handleLink('js-private-ad-motorcycle', () => {
        LogPrivateAdMotorcycleClick()
      })
    },
    handleCaravan() {
      this.handleLink('js-private-ad-caravan', () => {
        LogPrivateAdCaravanClick()
      })
    },
    handleLink(className, callback) {
      const link = document.getElementsByClassName(className)
      if (link.length > 0) {
        link[0].addEventListener('click', () => {
          callback()
        })
      }
    },
  },
}
</script>
